import React from 'react'

export const LightSpinner = () => {
    return (
        <div class="spinner-border text-light" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    )
}
